import React from "react";
import { Outlet } from "react-router-dom";
// import BG from "../../assets/images/BG.jpg";

interface Prop {
  basename: string;
}

export const MainLayoutAgendes: React.FC<Prop> = ({ basename }) => {
  return (
    <div className="content-register">
      <Outlet />
    </div>
  );
};
